export default "/images/af35c07ce9c3f307328a34c3b8740487.jpg";